import { render, staticRenderFns } from "./PaymentQR.vue?vue&type=template&id=0c25c5d3&scoped=true"
import script from "./PaymentQR.vue?vue&type=script&lang=js"
export * from "./PaymentQR.vue?vue&type=script&lang=js"
import style0 from "./PaymentQR.vue?vue&type=style&index=0&id=0c25c5d3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c25c5d3",
  null
  
)

export default component.exports